import { Card, Input, Select, Radio, Form } from "antd"
import React from "react"
import withEditable from "../childComponents/editableInputsHOC/withEditable.component";

// Example usage with different inputs
// Wrap AntD components with the HOC
const EditableInput = withEditable(Input);
const EditableSelect = withEditable(Select);
const EditableRadioGroup = withEditable(Radio.Group);
const ProfileComponent = ({ vendorDetails, updateVendorInfo }: any) => {
    const [form] = Form.useForm();

    const inputChange = (value: any, item: any) => {
        form.setFieldsValue({ [item.name]: value })
        vendorDetails[item.name] = value
        updateVendorInfo(vendorDetails)
    }

    const formItems = [
        { name: "vendorId", label: "VendorId", type: "input", initialValue: vendorDetails.vendorId, options: [], editable: false, hasHelp: false, helpOptions: [{ label: '', description: '' }] },
        { name: "ownersFullName", label: "Owner Full name", type: "input", initialValue: vendorDetails.ownersFullName, options: [], editable: true, hasHelp: false, helpOptions: [{ label: '', description: '' }] },
        { name: "ownerEmailAddress", label: "Owner Email Address", type: "input", initialValue: vendorDetails.ownerEmailAddress, options: [], editable: true, hasHelp: false, helpOptions: [{ label: '', description: '' }] },
        { name: "mobileNumber", label: "Mobile Number", type: "input", initialValue: vendorDetails.mobileNumber, options: [], editable: true, hasHelp: false, helpOptions: [{ label: '', description: '' }] },
    ];
    // Simulate API call
    const handleApiCall = (name: string, value: any) => {
        console.log(`API call for ${name}:`, value);
    };
    return (

        <Card title={<h2>Profile</h2>} style={{
            padding: '20px',

        }}>
            <div className="profile_flex">
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={Object.fromEntries(formItems.map((item) => [item.name, item.initialValue]))}
                >
                    <div className="profile-form-grid">
                        {formItems.map((item) => (

                            <Form.Item key={item.name} name={item.name} label={item.label} >
                                {item.type === "input" && (
                                    <EditableInput
                                        value={form.getFieldValue(item.name)}
                                        onChange={(value) => inputChange(value, item)}
                                        onSubmit={(value) => handleApiCall(item.name, value)}
                                        disabled={false}
                                        editable={item.editable}
                                        hasHelp={item.hasHelp}
                                        helpOptions={item.helpOptions}
                                    />
                                )}
                                {item.type === "select" && (
                                    <EditableSelect
                                        value={form.getFieldValue(item.name)}
                                        onChange={(value) => inputChange(value, item)}
                                        onSubmit={(value) => handleApiCall(item.name, value)}
                                        disabled={false}
                                        options={item.options}
                                        editable={item.editable}
                                        hasHelp={item.hasHelp}
                                        helpOptions={item.helpOptions}
                                    >
                                    </EditableSelect>
                                )}
                                {item.type === "radio" && (
                                    <EditableRadioGroup
                                        value={form.getFieldValue(item.name)}
                                        onChange={(value) => inputChange(value, item)}
                                        onSubmit={(value) => handleApiCall(item.name, value)}
                                        disabled={false}
                                        options={item.options}
                                        editable={item.editable}
                                        hasHelp={item.hasHelp}
                                        helpOptions={item.helpOptions}
                                    >
                                    </EditableRadioGroup>
                                )}
                            </Form.Item>
                        ))}
                    </div>

                </Form>
            </div>
        </Card >

    )
}

export default ProfileComponent




